export class EditReminderModel{
    public crmUserId:number;
    public description:string;
    public dueDateTime:string;
    public id:number;
    public markCompleted:boolean;
    public reminderStatus:string;
    public sessionToken:string;
    public title:string;
}